export default "__VITE_ASSET__irKt_AQE__"